module.exports = __webpack_public_path__ + "img/logo-blk.578b7dba.png";